import {ReferringSpecialistTitle} from '@/features/referring-specialists/types'

export const specialistTitleMapToLabel = {
    dr_male: 'referring_specialist:dr_male',
    dr_female: 'referring_specialist:dr_female',
    prof_male: 'referring_specialist:prof_male',
    prof_female: 'referring_specialist:prof_female'
} as const satisfies Record<ReferringSpecialistTitle, string>
